import Vue from "vue";
import Vuetify from "vuetify/dist/vuetify.js";
import "vuetify/dist/vuetify.min.css";


Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    defaultTheme: 'light',
  },
  
});

export default vuetify;
